<template>

<div class="side-container">
  <ul class="nav side">
    <div class="wrapper">
        <div class="sidenav-grid">
          <div class="grid-border"></div>
        </div>

        <template v-if="this.isAuthenticated">

          <li class="open">
              <div class="spacer"></div>
              <span v-if="lang === 'fr'">Liste des membres</span>
              <span v-else-if="lang === 'en'">Residencies</span>
<!--               <img class="search-map" src="./../assets/img/search-icon.svg" style="height: 30px;float: right;margin-right: 14px;">   
 -->              <div class="spacer"></div>
              <ul class="membres" v-if="membres">
                <template v-for="membre in membres">
                  <router-link v-if="lang === 'fr'" :to="{path: membre.url}" class="membre" :tag="'li'">
                      <a href="membre.url">{{membre.title}}</a>
                      <!-- ÉDITER PAGE -->
                      <button class="btn circle mini" 
                        @click="showEditMenuItemModal('page', 'membres', 'Membre', membre.title, membre.url)">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <!-- SUPPRIMER PAGE -->
                      <button class="btn circle mini" 
                        @click="showDeleteMenuItemModal(membre.url)">
                        <i class="fa fa-trash"></i>
                      </button>
                  </router-link>
                  <router-link v-else-if="lang === 'en'" :to="{path: '/en'+membre.url}" class="membre" :tag="'li'">
                      <a href="'/en'+membre.url">{{membre.title}}</a>
                      <!-- ÉDITER PAGE -->
                      <button class="btn circle mini" 
                        @click="showEditMenuItemModal('page', 'membres', 'Membre', membre.title, membre.url)">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <!-- SUPPRIMER PAGE -->
                      <button class="btn circle mini" 
                        @click="showDeleteMenuItemModal(membre.url)">
                        <i class="fa fa-trash"></i>
                      </button>
                  </router-link>
                </template>
              <div class="spacer"></div>
              <div class="add-buttons" style="width: 100%; text-align: left; margin-left:10px; margin-top:0px">
                <button @click="showCreateMenuItemModal('page', 'membres', 'Membre')" class="btn normal">
                  <i class="fa fa-plus"></i>&nbsp;Membre
                </button>
              </div>
              <div class="spacer"></div>
            </ul>
          </li>
      </template>
      <template v-else>
        <li class="open">
            <div class="spacer"></div>
              <span v-if="lang === 'fr'">Liste des membres</span>
              <span v-else-if="lang === 'en'">Residencies</span>
              <!--             <img class="search-map" src="./../assets/img/search-icon.svg" style="height: 30px;float: right;margin-right: 14px;">   
 -->            <div class="spacer"></div>
            <ul class="membres" v-if="membres">
                <template v-for="membre in membres">
                  <router-link v-if="lang === 'fr' " :to="{path: membre.url}" class="membre" :tag="'li'">
                      <a href="membre.url">{{membre.title}}</a>
                  </router-link>
                  <router-link v-else-if="lang === 'en' " :to="{path: '/en'+membre.url}" class="membre" :tag="'li'">
                      <a href="'/en'+membre.url">{{membre.title}}</a>
                  </router-link>
                </template>
          </ul>
        </li>
      </template>


    </div>
  </ul>

  <!--  CREATE MODAL-->                
  <Modal :show="createMenuItemModal.show" @close="createMenuItemModal.show = false" style="left:auto; right:0; width: 20%;">
      <div class="modal-header">
          <h3>Ajouter un membre”</h3>
      </div>
      <div class="modal-body">
          <label class="form-label">
            <input autofocus v-model="createMenuItemModal.title" class="form-control" placeholder="Entrer un nom">
          </label>
      </div>
      <div class="modal-footer text-right">
          <button class="btn normal" @click="createMenuItemModal.show = false">Annuler</button>
          <button class="btn normal" @click="createMenuItem('page')">Ajouter</button>
      </div>
  </Modal>

  <!--  EDIT MODAL-->                
  <Modal :show="editMenuItemModal.show" @close="editMenuItemModal.show = false" style="left:auto; right:0; width: 20%;">
      <div class="modal-header">
          <h3>Modifier le lien</h3>
      </div>
      <div class="modal-body">
          <label class="form-label">
            <input autofocus v-model="editMenuItemModal.title" class="form-control" placeholder="Entrer un nom">
          </label>
      </div>
      <div class="modal-footer text-right">
          <button class="btn normal" @click="editMenuItemModal.show = false">Annuler</button>
          <button class="btn normal" @click="editMenuItem('page')">Modifier</button>
      </div>
  </Modal>

  <!--  DELETE MODAL-->  
  <Modal :show="deleteMenuItemModal.show" @close="deleteMenuItemModal.show = false">
    <div>
      <div class="modal-header">
          <h3>Supprimer le membre ?</h3>
      </div>
      <div class="modal-footer text-left">
          <button class="btn normal" @click="deleteMenuItemModal.show = false">Annuler</button>
          <button class="btn normal" @click="deleteMenuItem()">OK</button>
      </div>
    </div>
  </Modal>

</div>

</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import Modal from './UI/Modal'

export default {
  name: 'SideNavigation',
  components: {
    Modal
  },
  props: ['lang'],
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userAuthenticated'
    ]),
    membres() {
      if (this.sideNavigation[0]){
        return this.sideNavigation[0].children
      }
    }
  },
  data () {
    return {
      sideNavigation: [],
      createMenuItemModal: {
        show : false,
        type: '',
        title : '',
        link_url: '',
        parentTitle: '',
        parentName: ''
      },
      editMenuItemModal: {
        show : false,
        type: '',
        title : '',
        url: '',
        parentTitle: '',
        parentName: '',
        link_url: ''
      },
      deleteMenuItemModal: {
        show : false,
        url: ''
      }
    }
  },
  methods: {
    getSideNavigation () {
      axios.get('/api/page/membres?getChildren&sort=name').then(response => {
        this.sideNavigation = []
        this.sideNavigation.push(response.data)
      })
      .catch(error => {
        console.log(error)
      })
    },
    showCreateMenuItemModal (type, parentName, parentTitle) {
      this.createMenuItemModal.show = true
      this.createMenuItemModal.type = type
      this.createMenuItemModal.parentName = parentName
      this.createMenuItemModal.parentTitle = parentTitle
    },
    showEditMenuItemModal (type, parentName, parentTitle, title, url, link_url) {
      this.editMenuItemModal.show = true
      this.editMenuItemModal.type = type
      this.editMenuItemModal.parentName = parentName
      this.editMenuItemModal.parentTitle = parentTitle
      this.editMenuItemModal.title = title
      this.editMenuItemModal.url = url
      this.editMenuItemModal.link_url = link_url
    },
    showDeleteMenuItemModal (url) {
      this.deleteMenuItemModal.show = true
      this.deleteMenuItemModal.url = url
    },
    createMenuItem () {
      var params = {
        pageTitle: this.createMenuItemModal.title,
        sideContent: '<h4>Contact</h4><p>'+ this.createMenuItemModal.title +'<br>3 Rue de la ville<br>xxxxx, Ville<br>contact@site.com</p>'
      }
      axios.post('/api/page/membres', params).then(response => {
        this.$notify({title: 'La page a été créée'})
        this.getSideNavigation()
        this.createMenuItemModal.show = false
      })
      .catch(error => {
        this.$notify({title: 'Erreur', text: error.data})
      })
    },
    editMenuItem () {
      var params = { pageTitle: this.editMenuItemModal.title }
      axios.put('/api/page' + this.editMenuItemModal.url, params).then(response => {
        this.$notify({title: 'La page a été modifiée'})
        this.getSideNavigation()
        this.editMenuItemModal.show = false
      })
      .catch(error => {
        this.$notify({title: 'Erreur', text: error.data})
      })
    },
    deleteMenuItem () {
      axios.delete('/api/page/' + this.deleteMenuItemModal.url).then((response) => {
        this.$notify({title: 'La page a été supprimé'})
        this.getSideNavigation()
        this.deleteMenuItemModal.show = false
        app.$router.push('/')
      })
      .catch(error => {
        this.$notify({title: 'Erreur', text: error.data})
      })
    }
  },
  created () {
    this.getSideNavigation()
  },
  watch: {
    mapIsReady (val) {
      console.log(val)
    },
    $route () {
      if (app.$route.path.split('/')[1] == 'en'){
        this.lang = 'en'
        this.getNavigation()
        this.getSideNavigation()
      }else{
        this.lang = 'fr'
        this.getNavigation()
        this.getSideNavigation()       
      }
      this.lang = global.lang
    }

  }
}
</script>

<style>
  ul.submenu .add-buttons{
    display: none;
  }

  ul.submenu:hover .add-buttons{
    display: block;
  }

  li.membre .btn{
    display: none;
  }

  li.membre:hover .btn{
    display: inline;
  }

</style>


// WEBPACK FOOTER //
// src/components/SideNavigation.vue